import { render, staticRenderFns } from "./image-slide.vue?vue&type=template&id=8e55f1fc&scoped=true&"
import script from "./image-slide.vue?vue&type=script&lang=js&"
export * from "./image-slide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e55f1fc",
  null
  
)

export default component.exports